<header id="header" class="header fixed-top">
  <nav class="navbar navbar-expand-lg appendClass">
    <div class="container">
      <div class="for_destop d-sm-none d-lg-flex justify-content-between w-100">
        <a class="navbar-brand" href="#"
          ><img src="assets/images/Logo.png"
        /></a>

        <ul class="navbar-nav mb-2 mb-lg-0">
          <li>
            <a
              class="nav-link"
              [ngClass]="{ active: currentRoute === 'artist-support' }"
              [routerLink]="['/artist-support']"
              >Support</a
            >
          </li>
          <li>
            <a
              class="nav-link br-left"
              [ngClass]="{ active: currentRoute === 'sign-in' }"
              href="{{appConfig.artistUrl}}" target="_blank"
              >Sign in</a
            >
          </li>
          <li>
            <a
              class="nav-link"
              [ngClass]="{ active: currentRoute === '' }"
              href="{{appConfig.artistUrl}}" target="_blank"
              >Get access</a
            >
          </li>
        </ul>
      </div>
      <div class="for_mobile w-100 d-lg-none d-sm-block">
        <div class="mobile_logo_view d-flex justify-content-between">
          <a class="navbar-brand for_mobile" href="#"
            ><img src="assets/images/Logo.png"
          /></a>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"
              ><img src="assets/images/menu.png "
            /></span>
          </button>
        </div>
        <div
          class="collapse navbar-collapse flexgrow"
          id="navbarSupportedContent"
        >
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li>
              <a
                class="nav-link"
                [ngClass]="{ active: currentRoute == 'artist-support' }"
                routerLink="/artist-support"
              >
                <div class="svg_icon">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3.0848 3.08304C2.40823 3.75759 1.9999 4.83395 1.9999 6.46485V10.8519C1.9999 12.9759 2.43292 13.9917 3.04588 14.5264C3.68602 15.0849 4.73394 15.3164 6.48016 15.3164H6.92018C7.19617 15.3164 7.4595 15.4017 7.66296 15.5023C7.86341 15.6013 8.09649 15.76 8.26619 15.99L9.58359 17.7412C9.7447 17.9554 9.90313 18.0012 10.0003 18.0012C10.0975 18.0012 10.256 17.9554 10.4171 17.7412L11.7371 15.9864L11.7402 15.9823C12.0568 15.567 12.5548 15.3164 13.0805 15.3164H13.5205C15.1579 15.3164 16.2388 14.9087 16.9159 14.2337C17.5924 13.5592 18.0008 12.4828 18.0008 10.8519V6.46485C18.0008 4.83395 17.5924 3.75759 16.9159 3.08304C16.2388 2.40805 15.1579 2.00039 13.5205 2.00039H6.48016C4.84279 2.00039 3.76182 2.40805 3.0848 3.08304ZM1.95513 1.94997C3.0382 0.870144 4.59736 0.400391 6.48016 0.400391H13.5205C15.4033 0.400391 16.9625 0.870144 18.0455 1.94997C19.129 3.03024 19.6008 4.58611 19.6008 6.46485V10.8519C19.6008 12.7306 19.129 14.2865 18.0455 15.3668C16.9625 16.4466 15.4033 16.9164 13.5205 16.9164H13.0805C13.0608 16.9164 13.0313 16.9286 13.0134 16.9514L13.0127 16.9523L11.6957 18.7031C11.276 19.261 10.6688 19.6012 10.0003 19.6012C9.33189 19.6012 8.72469 19.261 8.30497 18.7031L6.99387 16.9602C6.98543 16.9541 6.97186 16.9455 6.95403 16.9366C6.93333 16.9264 6.91482 16.9198 6.90248 16.9165L6.48016 16.9164C4.70621 16.9164 3.114 16.7091 1.99406 15.7321C0.846929 14.7314 0.399902 13.115 0.399902 10.8519V6.46485C0.399902 4.58611 0.87162 3.03024 1.95513 1.94997ZM7.5999 6.79402C7.5999 5.46903 8.66841 4.40039 9.99348 4.40039C11.3185 4.40039 12.3871 5.46903 12.3871 6.79402C12.3871 7.84666 11.6925 8.40098 11.2529 8.7014C11.0679 8.82921 10.9566 8.92458 10.8868 9.0182C10.8317 9.09215 10.7935 9.17599 10.7935 9.31883V9.52039C10.7935 9.96222 10.4353 10.3204 9.99348 10.3204C9.55165 10.3204 9.19348 9.96222 9.19348 9.52039V9.31883C9.19348 8.2427 9.9046 7.68802 10.3454 7.38369L10.3487 7.38136L10.3487 7.38137C10.5244 7.26141 10.6317 7.16836 10.6983 7.07857C10.7513 7.00698 10.7871 6.92707 10.7871 6.79402C10.7871 6.35261 10.4348 6.00039 9.99348 6.00039C9.55214 6.00039 9.1999 6.35261 9.1999 6.79402C9.1999 7.23585 8.84173 7.59402 8.3999 7.59402C7.95807 7.59402 7.5999 7.23585 7.5999 6.79402ZM9.98916 11.0152C9.54733 11.0152 9.18916 11.3734 9.18916 11.8152C9.18916 12.2571 9.54733 12.6152 9.98916 12.6152H9.9978C10.4396 12.6152 10.7978 12.2571 10.7978 11.8152C10.7978 11.3734 10.4396 11.0152 9.9978 11.0152H9.98916Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <span>Support</span>
              </a>
            </li>

            <li>
              <a
                class="nav-link"
                [ngClass]="{ active: currentRoute == 'sign-in' }"
                routerLink="/sign-in"
              >
                <div class="svg_icon">
                  <svg
                    width="14"
                    height="20"
                    viewBox="0 0 14 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4.04771 5.17265C4.04771 3.36768 5.39411 2.00039 6.95132 2.00039C8.50088 2.00039 9.85417 3.36812 9.85494 5.17111C9.84738 6.92383 8.58589 8.25516 7.10141 8.33444C7.00012 8.32731 6.89489 8.32769 6.79467 8.33454C5.3087 8.2562 4.04771 6.92402 4.04771 5.17265ZM6.95132 0.400391C4.40452 0.400391 2.44771 2.59382 2.44771 5.17265C2.44771 7.69848 4.315 9.84654 6.78069 9.93544C6.81621 9.93672 6.85178 9.93563 6.88715 9.93218C6.92998 9.928 6.97523 9.92879 6.99947 9.93139C7.03737 9.93546 7.07551 9.93681 7.11361 9.93544C9.57962 9.84653 11.4451 7.69873 11.4549 5.17575L11.4549 5.17265C11.4549 2.59261 9.48865 0.400391 6.95132 0.400391ZM11.7291 11.7864C10.4243 10.852 8.74062 10.4093 7.09524 10.4093C5.44934 10.4093 3.76245 10.8523 2.45045 11.7853L2.4475 11.7874C1.26843 12.6339 0.600098 13.8119 0.600098 15.0664C0.600098 16.321 1.26854 17.4971 2.44842 18.3394C3.75689 19.278 5.44262 19.7235 7.08899 19.7235C8.73567 19.7235 10.4217 19.2779 11.7303 18.3388C12.9094 17.4923 13.5779 16.3142 13.5779 15.0597C13.5779 13.8049 12.9092 12.6287 11.7291 11.7864ZM2.2001 15.0664C2.2001 14.4179 2.54069 13.6907 3.37918 13.0881L10.7973 17.039C9.812 17.746 8.47019 18.1235 7.08899 18.1235C5.70771 18.1235 4.36583 17.746 3.3805 17.0389L3.37875 17.0376C2.5406 16.4396 2.2001 15.7149 2.2001 15.0664ZM3.37918 13.0881L10.7973 17.039C11.6368 16.4362 11.9779 15.7085 11.9779 15.0597C11.9779 14.4112 11.6374 13.6865 10.7992 13.0884L10.798 13.0876C9.8173 12.3851 8.47752 12.0093 7.09524 12.0093C5.71387 12.0093 4.36928 12.3846 3.37918 13.0881Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <span>Sign in</span>
              </a>
            </li>
            <li>
              <a
                class="nav-link"
                [ngClass]="{ active: currentRoute == '' }"
                href=" # "
              >
                <div class="svg_icon">
                  <svg
                    width="18"
                    height="20"
                    viewBox="0 0 18 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.38213 10.6702C5.60502 10.6702 3.34478 8.36616 3.34478 5.53527C3.34478 2.70439 5.60502 0.400391 8.38213 0.400391C11.1592 0.400391 13.4195 2.70439 13.4195 5.53527C13.4195 8.36616 11.1592 10.6702 8.38213 10.6702ZM8.38213 1.73993C6.33215 1.73993 4.65888 3.4456 4.65888 5.53527C4.65888 7.62495 6.33215 9.33062 8.38213 9.33062C10.4321 9.33062 12.1054 7.62495 12.1054 5.53527C12.1054 3.4456 10.4321 1.73993 8.38213 1.73993ZM0.856996 19.6003C0.497812 19.6003 0.199951 19.2967 0.199951 18.9305C0.199951 15.1173 3.87064 12.0096 8.38235 12.0096C9.18738 12.0096 9.9779 12.1057 10.7473 12.3046C11.5248 11.5364 12.5454 11.1167 13.6387 11.1167C14.8301 11.1167 15.9602 11.6346 16.7312 12.5277C17.4145 13.3046 17.8 14.3048 17.8 15.3585C17.8 15.6979 17.7562 16.0372 17.6685 16.3587C17.5809 16.7606 17.4145 17.1803 17.1867 17.5464C16.4596 18.8145 15.0929 19.6004 13.6387 19.6004C12.6049 19.6004 11.6237 19.2075 10.8615 18.502C10.5549 18.2341 10.2833 17.9036 10.0731 17.5375C9.68763 16.8945 9.47738 16.1355 9.47738 15.3585C9.47738 14.6961 9.62544 14.0589 9.90326 13.4842C9.40767 13.3933 8.89895 13.3491 8.38235 13.3491C4.59777 13.3491 1.51404 15.8496 1.51404 18.9305C1.51404 19.2967 1.21618 19.6003 0.856996 19.6003ZM11.5975 13.3313C12.1406 12.7687 12.859 12.4562 13.6387 12.4562C14.4534 12.4562 15.2243 12.8045 15.75 13.4296C16.223 13.9654 16.4859 14.653 16.4859 15.3675C16.4859 15.5997 16.4596 15.8229 16.3982 16.0551C16.3369 16.332 16.223 16.6177 16.0741 16.8677C15.566 17.734 14.6286 18.2698 13.6387 18.2698C12.9378 18.2698 12.2632 18.0019 11.7376 17.5107C11.5273 17.3232 11.3434 17.0999 11.2032 16.8499C10.9316 16.4034 10.7915 15.8854 10.7915 15.3585C10.7915 14.5905 11.0806 13.8761 11.5975 13.3313ZM12.9815 16.0104H12.333C11.9738 16.0104 11.6759 15.7068 11.6759 15.3407C11.6759 14.9745 11.9738 14.6709 12.333 14.6709H12.9815V14.0367C12.9815 13.6706 13.2794 13.3669 13.6386 13.3669C13.9978 13.3669 14.2956 13.6706 14.2956 14.0367V14.6709H14.9524C15.3116 14.6709 15.6094 14.9745 15.6094 15.3407C15.6094 15.7068 15.3116 16.0104 14.9524 16.0104H14.2956V16.7068C14.2956 17.0819 13.9978 17.3766 13.6386 17.3766C13.2794 17.3766 12.9815 17.073 12.9815 16.7068V16.0104Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <span>Get Access</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</header>
